<template>
    <div>
        <Header></Header>
        <agent-form></agent-form>
        <agent-table></agent-table>
    </div>
</template>

<script>
import AgentForm from '@/components/dashboard/agent/AgentForm'
import Header from '@/components/dashboard/Header'
import AgentTable from '@/components/dashboard/agent/AgentTable'

export default {
    data() {
        return {
            
        }
    },
    components : {
        Header,
        AgentForm,
        AgentTable
    }
}
</script>
